import { Tween } from '../../../vendor_core/core/src/Tween';
import SoundVars from '../../../vendor_core/core/src/const/SoundVars';
import GameModel from '../../../vendor_core/core/src/model/GameModel';
import ReelCascadeBehaviour from "../../../vendor_core/core/src/spinners/ReelCascadeBehaviour";
import SoundController from '../../../vendor_core/core/src/utils/SoundController';
import ReelSymbol from '../../../vendor_core/core/src/views/Symbol';

class TRWReelCascadeBehaviour extends ReelCascadeBehaviour {
    private currentSymbolIndex: number;
    public get startSymbolsTweenPosition(): number {
        const symbolsHeight = this.reel.symbols
            .slice(this.currentSymbolIndex, this.reel.symbols.length)
            .reduce((acc, obj) => acc + obj.height * 2, 0);

        return this.reel.yOrigin - symbolsHeight;
    }
    public get endSymbolsTweenPosition(): number {
        const allSymbolsHeight = this.reel.symbols.reduce(
            (acc, obj) => acc + obj.height,
            500
        );

        const symbolsHeight = this.reel.symbols
            .slice(0, this.currentSymbolIndex)
            .reduce((acc, obj) => acc + obj.height, 0);

        return this.reel.yOrigin + allSymbolsHeight + symbolsHeight;
    }
    protected onCompleteFillExplode(): void {
        this.playReelStopSound(true)
    }
    protected onCompleteFillRemaining(hasAnticipation: boolean): void {
        this.playReelStopSound(true)
        this.symCascadeComplete(hasAnticipation);
    }

    protected stopMainDrop(hasAnticipation: boolean): void {
        super.stopMainDrop(hasAnticipation);
        if (!GameModel.turboSpin) {
            Tween.delayedCall(this.cascadeTL.totalDuration - 0.13, () => {
                this.playReelStopSound()
            })
        }
    }
    
    protected setFinalSymbols() {
        this.reel.sortSymbolsByY();
        this.stopSymbols.forEach((sym, index) => {
            /* 
                This is commented because it refreshes the idle symbol
                animation on every cascade. Uncomment if anything breaks
            */
            // this.reel.symbols[index].setId(sym);
        });
    }

    private playReelStopSound(onDropRemaining: boolean = false): void {
        const soundKey: string = onDropRemaining ? "newSymbolsDrop" : SoundVars.EFFECT_REEL_STOP;
        SoundController.playSound(soundKey, false, null, false);
    }
}

export default TRWReelCascadeBehaviour;
